import { IsInt, IsIn, IsUrl, ValidateIf, IsNotEmpty } from "class-validator";
import { Transform, Type } from "class-transformer";

export class ForwardingDto {
  isSubdomain: boolean = false

  @ValidateIf(o => o.isSubdomain === true)
  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  @IsNotEmpty({ message: 'validation.subdomain_must_be_a_valid_string' })
  subdomain: string;

  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  @IsUrl({ protocols: ["http", "https"], require_protocol: true },
    { message: "validation.destination_url_must_start_with_http_or_https" })
  destination_url: string;

  @Type(() => Number) // 👈 transform from string → number
  @IsInt({ message: "validation.status_code_must_be_an_integer" })
  @IsIn([301, 302], { message: "validation.status_code_must_be_either_301_permanent_or_302_temporary" })
  status_code: number;
}
